import { render, staticRenderFns } from "./LxSelectLocation.vue?vue&type=template&id=3f61c5eb&scoped=true"
import script from "./LxSelectLocation.vue?vue&type=script&lang=js"
export * from "./LxSelectLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f61c5eb",
  null
  
)

export default component.exports